import React from 'react';
import cn from 'classnames';
import { getAriaCellDay } from '../../../helpers/ariaComposers';
import { getDaysInMonth, isDateBGreaterThanDateA, isTwoDatesEqual } from '../../../helpers/dateFormatters';
import { ICalendarDate, ICalendarType } from '../../../Calendar';
import { ICalendarPosition } from '../../CalendarView';
require("./CalendarViewCell.css");
var styles = {
  "Root": "CalendarViewCell-module-Root_2dc",
  "RangeIndicator": "CalendarViewCell-module-RangeIndicator_3eq",
  "RangeIndicatorBox": "CalendarViewCell-module-RangeIndicatorBox_iZ2",
  "highlightedCurrent": "CalendarViewCell-module-highlightedCurrent_2Ri",
  "highlightedOther": "CalendarViewCell-module-highlightedOther_227",
  "EdgeIndicator": "CalendarViewCell-module-EdgeIndicator_2vz",
  "CellValue": "CalendarViewCell-module-CellValue_kKN",
  "SelectedDate": "CalendarViewCell-module-SelectedDate_22E",
  "DefaultDate": "CalendarViewCell-module-DefaultDate_3xf",
  "DisabledDate": "CalendarViewCell-module-DisabledDate_3mX"
};
export const CalendarViewCell = ({
  calendarType = 'single',
  calendarPosition = 'primary',
  dateOfCurrentViewBox,
  isDisabled = false,
  selectedDateOne,
  selectedDateTwo,
  onClick,
  isCurrentView = false,
  hasRoundedEndings = false
}) => {
  const isFirstDayOfMonth = dateOfCurrentViewBox.day === 1;
  const isLastDayOfMonth = dateOfCurrentViewBox.day === getDaysInMonth({
    year: dateOfCurrentViewBox.year,
    monthIndex: dateOfCurrentViewBox.monthIndex
  });
  let borderRadius = '0 0 0 0';
  if (hasRoundedEndings && isFirstDayOfMonth) {
    borderRadius = '1.2rem 0 0 1.2rem';
  } else if (hasRoundedEndings && isLastDayOfMonth) {
    borderRadius = '0 1.2rem 1.2rem 0';
  }
  const isHighligtedEdgeIndicatorBox = selectedDateOne && isTwoDatesEqual(dateOfCurrentViewBox, selectedDateOne) || selectedDateTwo && isTwoDatesEqual(dateOfCurrentViewBox, selectedDateTwo);
  const isHighlightedLeftRangeIndicatorBox = selectedDateOne && selectedDateTwo && (isDateBGreaterThanDateA(dateOfCurrentViewBox, selectedDateTwo) && isDateBGreaterThanDateA(selectedDateOne, dateOfCurrentViewBox) || isTwoDatesEqual(dateOfCurrentViewBox, selectedDateTwo));
  const isHighlightedRightRangeIndicatorBox = selectedDateOne && selectedDateTwo && (isDateBGreaterThanDateA(selectedDateOne, dateOfCurrentViewBox) && isDateBGreaterThanDateA(dateOfCurrentViewBox, selectedDateTwo) || isTwoDatesEqual(dateOfCurrentViewBox, selectedDateOne));
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, {
      [styles.otherMonth]: !isCurrentView,
      [styles.currentMonth]: isCurrentView
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.RangeIndicator),
    style: {
      borderRadius
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": `day-of-${isCurrentView ? 'currentMonth' : 'otherMonth'}-in-${calendarPosition}-calendar-${dateOfCurrentViewBox.day}-rangeIndicatorBox-left`,
    className: cn(styles.RangeIndicatorBox, {
      [styles.highlightedCurrent]: isCurrentView && isHighlightedLeftRangeIndicatorBox,
      [styles.highlightedOther]: !isCurrentView && isHighlightedLeftRangeIndicatorBox
    })
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": `day-of-${isCurrentView ? 'currentMonth' : 'otherMonth'}-in-${calendarPosition}-calendar-${dateOfCurrentViewBox.day}-rangeIndicatorBox-right`,
    className: cn(styles.RangeIndicatorBox, {
      [styles.highlightedCurrent]: isCurrentView && isHighlightedRightRangeIndicatorBox,
      [styles.highlightedOther]: !isCurrentView && isHighlightedRightRangeIndicatorBox
    })
  })), /*#__PURE__*/React.createElement("div", {
    "data-testid": `day-of-${isCurrentView ? 'currentMonth' : 'otherMonth'}-in-${calendarPosition}-calendar-${dateOfCurrentViewBox.day}-edgeIndicator`,
    className: cn(styles.EdgeIndicator, {
      [styles.highlightedCurrent]: isCurrentView && isHighligtedEdgeIndicatorBox,
      [styles.highlightedOther]: !isCurrentView && isHighligtedEdgeIndicatorBox
    })
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaCellDay({
      calendarType,
      calendarPosition,
      dayOfMonth: dateOfCurrentViewBox.day,
      monthType: isCurrentView ? 'current' : 'other'
    }),
    className: cn(styles.CellValue, {
      [styles.SelectedDate]: isHighligtedEdgeIndicatorBox,
      [styles.DefaultDate]: !isHighligtedEdgeIndicatorBox,
      [styles.DisabledDate]: isDisabled
    }),
    value: JSON.stringify({
      ...dateOfCurrentViewBox,
      calendarPosition
    }),
    onClick: onClick,
    disabled: isDisabled
  }, dateOfCurrentViewBox.day));
};